import { render, staticRenderFns } from "./fox-creek.vue?vue&type=template&id=4f21fa60&scoped=true"
import script from "./fox-creek.vue?vue&type=script&lang=js"
export * from "./fox-creek.vue?vue&type=script&lang=js"
import style0 from "./fox-creek.vue?vue&type=style&index=0&id=4f21fa60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f21fa60",
  null
  
)

export default component.exports